import * as gameData from '../assets/data/enum';
import Gun from '../managers/Gun';
import PowerUp from '../managers/PowerUp';
import Magnet from './magnet';
import Car from './car';
import MovementController from '../managers/MovementController';
import { Physics, Tweens } from 'phaser';
export default class Player extends Phaser.GameObjects.Container {
    private MAX_HEALTH: number;
    private _gun: Gun;
    private _defaultMagnetRadius: number = 1;
    private _joystick: MovementController;
    private _explosion: Phaser.GameObjects.Sprite;
    private _crashAudio: Phaser.Sound.BaseSound;
    private _coinAudio: Phaser.Sound.BaseSound;

    private _shieldFx: Phaser.GameObjects.Sprite;
    private _magnetFx: Phaser.GameObjects.Sprite;

    private _laserFX_1: Phaser.GameObjects.Sprite;
    private _laserFX_2: Phaser.GameObjects.Sprite;
    private _2x_Multiplier: Phaser.GameObjects.Sprite;
    public _laserBullet_1: Physics.Arcade.Image;
    public _laserBullet_2: Physics.Arcade.Image;

    private _laserFxTween: Tweens.Tween;
    private _laserBulletTween: Tweens.Tween;

    public speed: number;
    public health: number = 10;
    public magnet: Magnet;
    public powerUp: PowerUp;
    public car: Car;
    public shadow: Phaser.GameObjects.Image;
    public tag: string;
    public boundary: { l: number, r: number };

    private _updateCounter: number;
    private _updateCounterMax: number;

    constructor(scene: Phaser.Scene, x: number, y: number, container: Phaser.GameObjects.Container, key: string, frame?: string,) {
        super(scene, x, y);
        this.setScale(window.constants["OBJECT_SCALE"]);
        this.tag = frame;
        // this.tag = key
        if (container) {
            container.add(this);
        }

        this.tag = "player";

        this._magnetFx = this.scene.add.sprite(0, 0, "assets", 'magnet_0');
        this.add(this._magnetFx);

        // this.shadow = this.scene.add.image(0, 0, "assets", this.tag + "_shadow");
        this.shadow = this.scene.add.image(0, 0, "car_06_shadow");
        this.setCarShadow();
        this.add(this.shadow);

        this.car = new Car(this.scene, 0, 0, this, key, frame);
        this.boundary = {
            l: (this.car.width),
            r: window.constants.BASE_WIDTH - (this.car.width)
        };

        this._joystick = new MovementController(this.scene, this);
        this._joystick.start();

        this._createGun();

        this.setMaxHealth();
        this.health = this.MAX_HEALTH;

        this._defaultMagnetRadius = Math.floor(this.car.height * 0.5);
        this.magnet = new Magnet(this.scene, this.x, this.y, null, this._defaultMagnetRadius, this.car);
        this.powerUp = new PowerUp(this.scene.scene.get('HUDScene'), this, this._endPowerupCallback);
        this.powerUp.setDepth(5);
        // this._gun.shoot(gameData.bulletType.player , 0);

        this._explosion = this.scene.add.sprite(0, 0, "assets", 'explosion_0');

        this._explosion.setVisible(false);
        // this._explosion.setScale(4);
        this._crashAudio = this.scene.sound.add("crash", {
            loop: false,
            volume: window.constants["VOLUME"]
        });

        this._coinAudio = this.scene.sound.add("coin", {
            loop: false,
            volume: window.constants["VOLUME"] * 1
        });

        this._shieldFx = this.scene.add.sprite(0, 0, "assets", 'shield_0');
        // this._shieldFx.setPosition(0, -this._shieldFx.height * 0.05);
        this.add(this._shieldFx);

        this.setMagnetFxVisibility(false);
        this.setShieldFxVisibility(false);

        this._updateCounter = 3;
        this._updateCounterMax = 3;
    }

    public setShieldFxVisibility(show) {
        if (show) {
            this._shieldFx.anims.play('shield_anim');
        } else {
            this._shieldFx.anims.stop();
            this._shieldFx.setVisible(false);
        }
    }

    public setMagnetFxVisibility(show) {
        if (show) {
            this._magnetFx.anims.play('magnet_anim');
        } else {
            this._magnetFx.anims.stop();
            this._magnetFx.setVisible(false);
        }
    }

    private _createGun() {
        this.tag = "player";
        let bulletImage = this.scene.textures.getFrame("assets", "player_bullet");
        let bulletCount = Math.floor(window.constants.BASE_HEIGHT / (bulletImage.height * 0.5));
        let bulletSpeed = window.constants.DATA.speed["bullet_player"]
        let colliderData = JSON.parse(JSON.stringify(window.constants.DATA["colliderOffset"]["gun_" + this.tag]));
        // let offset = {
        //     x: 2, y: (-this.car.height * colliderData.y), cx = co
        // }
        let barrel = this.scene.textures.getFrame("assets", 'gun_' + this.tag);
        colliderData.x = Math.floor(this.car.width * 0.01);
        colliderData.y = (-this.car.height * colliderData.y);
        let bulletOffset = Math.floor(this.car.width * 0.13);
        colliderData.bx = [colliderData.x, colliderData.x - bulletOffset, colliderData.x + bulletOffset]
        colliderData.by = [colliderData.y - (barrel.height), colliderData.y - (barrel.height), colliderData.y - (barrel.height)]

        this._gun = new Gun("pg", "assets", "player_bullet", bulletCount, bulletSpeed, gameData.bulletType.player, colliderData, this, -1, this.parentContainer, null, window.constants.DATA.rateOfFire.bullet_player);
        this._gun.showBarrel();
    }

    public _multiplierMultiplierVisiblity(show) {
        if (show) {
            this._2x_Multiplier.setVisible(true)
        } else {
            this._2x_Multiplier.setVisible(false)
        }
    }

    public setLaserFxVisibility(show) {
        if (show) {
            this._laserFX_1.setVisible(true);
        } else {
            this._laserFX_1.setVisible(false);
        }
    }

    private _endPowerupCallback() {

    }

    public setMagnetRadius(r: number) {
        this.magnet.setRadius(r);
    }

    public getScene() {
        return this.scene;
    }

    public getBullets() {
        if (this._gun) {
            return this._gun.bullets;
        }
        return null;
    }

    public setPoints(points, x?: number, y?: number) {
        if (points >= 0) {
            window.constants["POINTS"].push(points);
            window.constants["UPDATE_POINTS"] = true;
        }
    }

    public setHealth(health) {
        if (typeof health == "number") {
            this.health += health;

            switch (window.constants["CAR_CHOOSEN"]) {
                case 0:
                    this.health = Math.max(Math.min(this.health, 10), 0);
                    break;
                case 1:
                    this.health = Math.max(Math.min(this.health, 11), 0);
                    break;
                case 2:
                    this.health = Math.max(Math.min(this.health, 11), 0);
                    break;
                case 3:
                    this.health = Math.max(Math.min(this.health, 12), 0);
                    break;
                case 4:
                    this.health = Math.max(Math.min(this.health, 12), 0);
                    break;
                case 5:
                    this.health = Math.max(Math.min(this.health, 13), 0);
                    break;
                case 6:
                    this.health = Math.max(Math.min(this.health, 13), 0);
                    break;
            }
            this.scene.registry.set("health", this.health);
            this.scene.events.emit("healthChanged");
            if (this.health <= 0) {
                this.car.setBrokenTexture();
                this.magnet.stop();
                this._explosion.setPosition(this.x, this.y);
                this._explosion.play("explosion_anim");
                this._crashAudio.play();
            }
        }
    }

    public hit(key, value) {
        if (!window.constants["GAME_OVER"] && this.health > 0) {
            switch (key) {
                case "health":
                    this.setHealth(value);
                    this.car.healthPackTween();
                    break;
                case "coin_flip_0":
                    this.setPoints(value);
                    this._coinAudio.play();
                    break;
                case "sedan":
                case "hatchback":
                case "buggy":
                case "ambulance":
                case "fuel_truck":
                case "battle_truck":
                case "obstacle":
                case "missile":
                case "bullet":
                case "enemy_bullet":
                    {
                        if (!this.powerUp.flags.shield) {
                            if (window.navigator.vibrate) {
                                window.navigator.vibrate(20);
                            }
                            this.setHealth(-value);
                            this.scene.cameras.main.shake(100, 0.01);
                        }
                        // else {
                        //     if(key == "missile") {
                        //         if(window.navigator.vibrate) {
                        //             window.navigator.vibrate(100);
                        //         }
                        //         this.setHealth(-value);
                        //         this.scene.cameras.main.shake(100, 0.01);
                        //     }
                        // }
                    }
                    break;
                case "magnet":
                case "shield":
                case "split_shooter":
                    this.powerUp.start(key);
                    break;
            }
        }
    }

    public changeGun(type: gameData.bulletType) {
        this._gun.setGunType(type);
    }

    public start() {
        this.setMaxHealth();
        this.setHealth(this.MAX_HEALTH);
        this.setCarShadow();
        this.setActive(true);
        this._gun.shoot(gameData.bulletType.player, 0);
        this._joystick.start();
        this.magnet.start();
        this.car.start();
    }

    setMaxHealth() {
        switch (window.constants["CAR_CHOOSEN"]) {
            case 0:
                this.MAX_HEALTH = window.constants.DATA.health.player;
                break;
            case 1:
                this.MAX_HEALTH = 11;
                break;
            case 2:
                this.MAX_HEALTH = 11;
                break;
            case 3:
                this.MAX_HEALTH = 12;
                break;
            case 4:
                this.MAX_HEALTH = 12;
                break;
            case 5:
                this.MAX_HEALTH = 13;
                break;
            case 6:
                this.MAX_HEALTH = 13;
                break;
        }
    }

    setCarShadow() {
        switch (window.constants["CAR_CHOOSEN"]) {
            case 0:
                this.shadow.setTexture("assets", this.tag + "_shadow");
                this.shadow.setOrigin(0.65, 0.5);
                break;
            case 1:
                this.shadow.setTexture("car_01_shadow");
                this.shadow.setOrigin(0.72, 0.48);
                break;
            case 2:
                this.shadow.setTexture("car_02_shadow");
                this.shadow.setOrigin(0.73, 0.46);
                break;
            case 3:
                this.shadow.setTexture("car_03_shadow");
                this.shadow.setOrigin(0.73, 0.46);
                break;
            case 4:
                this.shadow.setTexture("car_04_shadow");
                this.shadow.setOrigin(0.83, 0.46);
                break;
            case 5:
                this.shadow.setTexture("car_05_shadow");
                this.shadow.setOrigin(0.73, 0.46);
                break;
            case 6:
                this.shadow.setTexture("car_06_shadow");
                this.shadow.setOrigin(0.75, 0.46);
                break;
        }
    }

    public stop() {
        this.powerUp.stop();
        this._gun.stop(false, true);
        this.setActive(false);
        this._joystick.stop();
        this.magnet.stop();
        this.car.stop();
    }

    public reset() {
        this.setAngle(0);
        this.setX(Math.floor(window.constants["BASE_WIDTH"] * 0.5))
        this.car.reset();
        this.powerUp.stop();
        this._gun.stop(true, true);
        this._gun.showBarrel();
    }

    update(time: number, dt: number) {
        this._joystick.update(time, dt);
        // this.car.update(time, dt);
        this.magnet.update(time, dt);
        if (this.powerUp.active) {
            this.powerUp.update(time, dt);
        }

        if (!this._updateCounter--) {
            this._updateCounter = this._updateCounterMax;
            if (this._gun) {
                this._gun.update(time, dt);
            }
        }
    }


}